import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useAction } from '@agro-club/frontend-shared'
import CompanyActions from '../../../../../modules/domain/company/duck'
import CompanySelectors from '../../../../../modules/domain/company/selectors'
import { CompanyListRequestFilter } from '../../../../../modules/domain/company/types'
import AntDTerritorySelect from '../../../TerritorySelect/AntDTerritorySelect'

type AssetCompanyTerritoryFilterSelectProps = {
  companyIds: string[]
}
const AssetCompanyTerritoryFilterSelect: React.FC<AssetCompanyTerritoryFilterSelectProps> = ({ companyIds }) => {
  const { t } = useTranslation('labels')
  const filter = useSelector(CompanySelectors.listByIdsFilter)
  const filterUpdated = useAction(CompanyActions.listByIdsFilterUpdated)

  const onSelectedTerritory = (values: string[]) => {
    if (values.length > 0) {
      handleFilterChange({ territory_id: values[0] })
      return
    }
    handleFilterChange({ territory_id: undefined })
  }

  const handleFilterChange = useCallback(
    (newFilterValue: Partial<CompanyListRequestFilter>) => {
      filterUpdated({ company_ids: companyIds, filters: { ...filter, ...newFilterValue } })
    },
    [filterUpdated, companyIds, filter],
  )

  return <AntDTerritorySelect placeholder={t('territory')} title={t('territory')} onChange={onSelectedTerritory} />
}

export default AssetCompanyTerritoryFilterSelect
